export const LOGIN_WITH_OAUTH_LOADING = "LOGIN_WITH_OAUTH_LOADING";
export const LOGIN_WITH_OAUTH_SUCCESS = "LOGIN_WITH_OAUTH_SUCCESS";
export const LOGIN_WITH_OAUTH_FAIL = "LOGIN_WITH_OAUTH_FAIL";

export const LOGIN_LOCAL_LOADING = "LOGIN_LOCAL_LOADING";
export const LOGIN_LOCAL_SUCCESS = "LOGIN_LOCAL_SUCCESS";
export const LOGIN_LOCAL_FAIL = "LOGIN_LOCAL_FAIL";

export const SIGNUP_LOCAL_LOADING = "SIGNUP_LOCAL_LOADING";
export const SIGNUP_LOCAL_SUCCESS = "SIGNUP_LOCAL_SUCCESS";
export const SIGNUP_LOCAL_FAIL = "SIGNUP_LOCAL_FAIL";

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

export const ME_LOADING = "ME_LOADING";
export const ME_SUCCESS = "ME_SUCCESS";
export const ME_FAIL = "ME_FAIL";

export const COMPLETE_SENDER_DETAILS_STEP = "COMPLETE_SENDER_DETAILS_STEP";
export const COMPLETE_RECEIVER_DETAILS_STEP = "COMPLETE_RECEIVER_DETAILS_STEP";
export const COMPLETE_ITEM_DETAILS_STEP = "COMPLETE_ITEM_DETAILS_STEP";
export const COMPLETE_RATE_SELECTION_STEP = "COMPLETE_RATE_SELECTION_STEP";
export const COMPLETE_CHECKOUT_DETAILS_STEP = "COMPLETE_CHECKOUT_DETAILS_STEP";
export const PREVIOUS_STEP = "PREVIOUS_STEP";
export const SELECT_QUOTE = "SELECT_QUOTE";
export const RESET_STATE = "RESET_STATE";
export const SET_KEPT_ADDRESS = "SET_KEPT_ADDRESS";

export const CLEAR_AUTH_ERROR = "CLEAR_AUTH_ERROR";

export const SET_AUTOCOMPLETE_ENABLED_FROM = "SET_AUTOCOMPLETE_ENABLED_FROM";
export const SET_AUTOCOMPLETE_ENABLED_TO = "SET_AUTOCOMPLETE_ENABLED_TO";

export const HYDRATE_DRAFT = "HYDRATE_DRAFT";

